import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class MainInterceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, httpHandler: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedRequest = httpRequest.clone({
      setHeaders: {
        'Accept-Language': 'fr',
      },
    });
    return httpHandler.handle(modifiedRequest);
  }
}
